/*
  pdp-sticky-bar.js
  ─────────────────
  StickyBuyBar behavior (Figma comment #24): the bar is visible ONLY
  while the main add-to-cart control is out of the viewport. Desktop
  docks under the header, mobile docks to the bottom (CSS). The bar's
  quantity display mirrors the main quantity control; the buy click is
  delegated to the main form via global.js's add-to-cart-og action.
*/
(function () {
  if (window.__ggmStickyBar) return;
  window.__ggmStickyBar = true;

  function init() {
    var bar = document.querySelector('[data-sticky-buy-bar]');
    var mainAtc = document.querySelector('.pm__product-atc-wrapper');
    if (!bar || !mainAtc || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);

    // Rita #44: the bar's quantity behaves exactly like the main control —
    // dropdown 1-9, "+10" switches to a typed number field. Both stay in
    // two-way sync with the main quantity input (the only form-bound field).
    var qtyWrap = bar.querySelector('[data-sticky-qty-wrap]');
    var qtySelect = bar.querySelector('[data-sticky-qty-select]');
    var qtyField = bar.querySelector('[data-sticky-qty]');
    var qtyInput = document.querySelector('.pm__quantity-input');
    var mainWrap = document.querySelector('quantity-input.pm__quantity');
    var mainSelect = document.querySelector('.pm__quantity-select');

    if (qtyWrap && qtySelect && qtyField && qtyInput) {
      var showSticky = function (v) {
        v = parseInt(v, 10) || 1;
        if (v <= 9) {
          qtyWrap.classList.remove('pdp-stickybar__qty--manual');
          qtySelect.value = String(v);
        } else {
          qtyWrap.classList.add('pdp-stickybar__qty--manual');
        }
        if (qtyField.value !== String(v)) qtyField.value = v;
      };

      var pushToMain = function (v) {
        v = parseInt(v, 10);
        if (!v || v < 1) return;
        if (qtyInput.value !== String(v)) {
          qtyInput.value = v;
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Mirror the main control's visible state (values set silently —
        // quantity-select.js only reacts to user-driven changes)
        if (mainSelect) mainSelect.value = v <= 9 ? String(v) : 'more';
        if (mainWrap) mainWrap.classList.toggle('pm__quantity--manual', v > 9);
      };

      qtySelect.addEventListener('change', function () {
        if (qtySelect.value === 'more') {
          qtyWrap.classList.add('pdp-stickybar__qty--manual');
          qtyField.value = 10;
          qtyField.focus();
          qtyField.select();
          pushToMain(10);
        } else {
          qtyField.value = qtySelect.value;
          pushToMain(qtySelect.value);
        }
      });

      qtyField.addEventListener('input', function () {
        pushToMain(qtyField.value);
      });
      qtyField.addEventListener('change', function () {
        pushToMain(qtyField.value);
      });
      qtyField.addEventListener('blur', function () {
        if (!parseInt(qtyField.value, 10)) showSticky(qtyInput.value);
      });

      var syncFromMain = function () {
        showSticky(qtyInput.value);
      };
      qtyInput.addEventListener('input', syncFromMain);
      qtyInput.addEventListener('change', syncFromMain);
      syncFromMain();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
